import React, { useContext, useEffect, useState } from "react";

import { useNavigate, Link } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff } from "lucide-react";
// import Input from "@material-ui/core/Input";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

import { loginWithEmail, updateUserSession } from "../../services/firebase";
import AuthContext from "../../hooks/authContext";
import validator from "validator";
import { findClientsByEmail, saveLogins, syncClientContactLogin } from "../../services/apiservices/client";
import { DOMAIN_TYPE, DOMAIN_TYPES } from "../../services/config";
import { CMS_EVENTS, trackEvent } from "../../services/apiservices/analytics";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alertDialog";
// import { Button } from "../";
// import { Input } from "@/components/ui/input";
// import { useToast } from "@/hooks/use-toast";
// import { useAuth } from "@/contexts/AuthContext";

const LoginForm = (props) => {
  const navigate = useNavigate();
  // const { toast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  // const { login } = useAuth();
  const auth = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showForceLoginDialog, setShowForceLoginDialog] = useState(false);
  const [pendingLoginData, setPendingLoginData] = useState(null);
  const [state, setState] = useState({
    formState: { username: "", password: "" },
    loading: false,
    sRedirect: "",
    remember: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== "") {
      setState({ ...state, formState: { ...state.formState, [name]: value } });
    }
  };
  const setInitState = () => {
    setState({
      ...state,
      remember: localStorage.remember,
      sRedirect: "",
      formState: {
        ...state.formState,
        username: localStorage.username,
        // password: localStorage.password,
      },
    });
  };
  useEffect(() => {
    if (localStorage.remember && localStorage.username !== "") {
      setInitState();
    }
  }, []);
  const redirecifloggedin = () => {
    navigate("/dashboard");
  };
  useEffect(() => {
    if (auth.status === true) {
      redirecifloggedin();
    }
  }, [auth.status]);

  const onChangeCheckbox = (event) => {
    setState({ ...state, remember: event.target.checked });
  };

  const isRoleAllowedForDomain = (userRoles = []) => {
    const isClient = userRoles.includes("Client");
    const isSuperUser = userRoles.includes("superUser");

    switch (DOMAIN_TYPE) {
      case DOMAIN_TYPES.SUPERUSER_ONLY:
        return isSuperUser;

      case DOMAIN_TYPES.CLIENT_ONLY:
        return isClient;

      case DOMAIN_TYPES.ALL:
      default:
        return true;
    }
  };

  const handleForceLogin = async () => {
    if (!pendingLoginData) return;

    try {
      setState((prev) => ({ ...prev, loading: true }));

      const newSessionId = Date.now().toString() + Math.random().toString(36).substring(2);

      await updateUserSession(pendingLoginData.userId, newSessionId);
      localStorage.setItem("sessionId", newSessionId);

      auth.login(pendingLoginData.token);

      if (pendingLoginData.role === "superUser") {
        navigate("/superuserDashboard");
      } else {
        navigate("/dashboard");
      }

      await postLoginProcess(pendingLoginData);
    } catch (error) {
      setErrorMessage("Failed to establish new session.");
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
      setShowForceLoginDialog(false);
      setPendingLoginData(null);
    }
  };

  const handleCancelLogin = () => {
    setShowForceLoginDialog(false);
    setPendingLoginData(null);
  };

  const postLoginProcess = async (loginRes) => {
    saveLogins(loginRes.userId);
    syncClientContactLogin(loginRes.userId, loginRes.user?.email);

    const data = await findClientsByEmail(loginRes?.user?.email);

    if (data?.clients?.length > 0 && data?.companies?.length > 0) {
      localStorage.setItem("companies", JSON.stringify(data.companies));
      localStorage.setItem("clients", JSON.stringify(data.clients));
      localStorage.setItem("companyId", data.clients[0]?.companyId);
      localStorage.setItem("clientId", data.clients[0]?.id);
    }

    trackEvent(CMS_EVENTS.LOGIN_SUCCESS, {
      user_id: loginRes?.userId,
    });
  };

  const userlogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    const { remember } = state;

    let { username, password } = formState;
    username = username?.trim();
    password = password?.trim();

    if (!username || !password) {
      setErrorMessage("Email and Password are required");
      return;
    }

    if (remember) {
      localStorage.username = username;
      localStorage.password = password;
      localStorage.remember = remember;
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("remember");
    }

    if (!validator.isEmail(username)) {
      setErrorMessage("Invalid email address");
      return;
    }

    try {
      setState((prev) => ({ ...prev, loading: true }));

      const loginRes = await loginWithEmail(username, password);

      trackEvent(CMS_EVENTS.USER_LOGIN, {
        user_id: auth?.userProfile?.id || loginRes?.userId,
      });

      if (!loginRes?.token) {
        setErrorMessage("Email or password does not match");

        trackEvent(CMS_EVENTS.LOGIN_FAILED, {
          user_id: auth?.userProfile?.id,
        });

        return;
      }

      const role = loginRes?.role;
      const userRoles = Array.isArray(role) ? role : [role];

      if (!isRoleAllowedForDomain(userRoles)) {
        setErrorMessage("You are not allowed to login from this domain");
        return;
      }

      const localSessionId = localStorage.getItem("sessionId");

      if (loginRes.existingSessionId && loginRes.existingSessionId !== localSessionId) {
        setPendingLoginData(loginRes);
        setShowForceLoginDialog(true);
        return;
      }

      const sessionId = localSessionId || Date.now().toString() + Math.random().toString(36).substring(2);

      await updateUserSession(loginRes.userId, sessionId);
      localStorage.setItem("sessionId", sessionId);

      auth.login(loginRes.token);

      if (loginRes.role === "superUser") {
        navigate("/superuserDashboard");
      } else {
        navigate("/dashboard");
      }

      await postLoginProcess(loginRes);
    } catch (error) {
      console.error(error);
      setErrorMessage("Login failed. Please try again.");
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  const { formState, loading, remember, sRedirect } = state;
  const { classes } = props;

  // Simplified login - no validation or authentication required
  const handleLogin = () => {
    // // Just log in without checking credentials
    // login("demo@proteams.io", "demo-password");

    // toast({
    //   title: "Welcome back!",
    //   description: "You've successfully logged in.",
    // });
    navigate("/");
  };

  return (
    <div className="space-y-5 sm:space-y-6 w-full px-4 sm:px-0">
      {/* Email field - no validation */}
      <div className="space-y-2">
        <label htmlFor="email" className="block text-sm font-medium">
          Email Address
        </label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            fullWidth={true}
            disableUnderline={true}
            onChange={handleInputChange}
            value={formState.username}
            autoComplete="email"
            className="pl-40 dark:bg-white"
            name="username"
            id="username"
            placeholder="Email"
          />
        </div>
      </div>

      {/* Password field - no validation */}
      <div className="space-y-2">
        <div className="flex justify-between items-baseline">
          <label htmlFor="password" className="block text-sm font-medium">
            Password
          </label>
          <Link
            to="/forgotpassword"
            className="text-sm text-green-600 hover:text-green-800"
          >
            Forgot password?
          </Link>
        </div>
        <div className="relative">
          <Lock className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            fullWidth={true}
            disableUnderline={true}
            onChange={handleInputChange}
            value={formState.password}
            autoComplete="current-password"
            className="pl-40 dark:bg-white"
            name="password"
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>

      {/* Login button - no form validation */}

      <Button
        type="button"
        className="w-full"
        onClick={userlogin}
        size="lg"
        disabled={loading ? true : false}
      >
        {loading ? "Loading..." : "LOG IN"}
      </Button>
      {errorMessage !== "" && (
        <div className="text-center text-red-600 text-sm font-medium mt-4">{errorMessage}</div>
      )}

      <div className="text-center text-sm text-gray-500">
        Don't have an account?{" "}
        <Link
          to="/register"
          className="text-green-600 hover:text-green-800 font-medium"
        >
          Start your free trial
        </Link>
      </div>

      <AlertDialog open={showForceLoginDialog} onOpenChange={setShowForceLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Account Already Logged In</AlertDialogTitle>
            <AlertDialogDescription>
              A user is already logged in with this account on another device.
              Do you want to force login and log out from the other session?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancelLogin}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleForceLogin}>Force Login</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default LoginForm;
